<span class="delivery" *ngIf="model">
  <i class="la" [ngClass]="{'la-truck': isDelivery, 'la-store-alt': !isDelivery }"></i>
  <i class="la la-paperclip" [ngClass]="{invisible: !model.fileExists}"></i>
  <i class="la la-birthday-cake" [ngClass]="{invisible: !model.decorExists}"></i>
  <i class="la la-birthday-cake" [ngClass]="{invisible: !model.decorText || model.decorExists}" [title]="model.decorText"></i>
  <i class="la la-comment" [ngClass]="{invisible: !model.note}" [title]="model.note"></i>
  <i class="la la-copyright" [ngClass]="{invisible: !isLegal}"></i>
</span>
